import { render, staticRenderFns } from "./WeekdaysSelector.vue?vue&type=template&id=4f78b667&scoped=true&"
import script from "./WeekdaysSelector.vue?vue&type=script&lang=js&"
export * from "./WeekdaysSelector.vue?vue&type=script&lang=js&"
import style0 from "./WeekdaysSelector.vue?vue&type=style&index=0&id=4f78b667&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f78b667",
  null
  
)

export default component.exports